const appDefaultTitle = 'Evinced Product Hub';

export const getPageTitle = (pageTitle): string => {
	return pageTitle ? `${pageTitle} | ${appDefaultTitle}` : appDefaultTitle;
};
